<template>
  <div>
    <lateralNavigation2></lateralNavigation2>
    <rightNav></rightNav>
  <div class="orderDetail">
      <div class="banxin">
          <div class="head">
              <router-link to="/myOrder">
                <div class="mar-right-10">我的订单</div>
              </router-link>
            <div class='arrow'></div>
            <div class="mar-right-10">订单详情</div>
          </div>
          <div class="status">
              <div class="left">
                  <p class="fs16 fw-blod mar-top-20 mar-bot-60">订单号：{{orderDetail.orderCd}}</p>
                  <div class="box" v-if="orderDetail.payType != 'payByArrive'&&orderDetail._status._type==0">
                      <p class="fs24 fw-blod mar-bot-10 font-color-71B">等待付款</p>
                  </div>
                  <div class="" v-if="orderDetail._status._type==1 ">
                      <p class="fs24 fw-blod font-color-FF7">待发货</p>
                  </div>
                  <div class="" v-if="orderDetail._status._type==1">
                      <p class="fs24 fw-blod mar-bot-10 font-color-FF7">运输中</p>
                  </div>
                  <div class="" v-if="orderDetail._status._type==2">
                      <p class="fs24 fw-blod mar-bot-10 font-color-71B">待收货</p>
                  </div>
                  <div class="" v-if="orderDetail._status._type==3">
                      <p class="fs24 fw-blod mar-bot-10 font-color-71B">待评价</p>
                  </div>
                  <div class="" v-if="orderDetail._status._type==4 ">
                      <p class="fs24 fw-blod mar-bot-10 font-color-71B">已完成</p>
                  </div>
<!--                  <div class="" v-if="orderDetail.status==5">-->
<!--                      <p class="fs24 fw-blod mar-bot-10 font-color-71B">已关闭</p>-->
<!--                  </div>-->
                  <div v-if="orderDetail._status._type==-1">
                      <p class="fs24 fw-blod mar-bot-10 font-color-FF7">申请退货</p>
                  </div>
                  <div v-if="orderDetail.state==6">
                      <p class="fs24 fw-blod mar-bot-10 font-color-71B">已取消</p>
                  </div>
                  <div v-if="orderDetail._status._type==-2">
                      <p class="fs24 fw-blod mar-bot-10 font-color-FF7">退货成功</p>
                  </div>
                  <div v-if="orderDetail._status._type==-2">
                      <p class="fs24 fw-blod mar-bot-10 font-color-71B">已退款</p>
                  </div>
              </div>
              <div class="right">
                  <StatusOne :createTime="orderDetail.createTime" v-if="orderDetail._status._type==0"></StatusOne>
                  <StatusTwo :createTime="orderDetail.createTime" v-if="orderDetail._status._type==1" :payType="orderDetail._status._payType"></StatusTwo>
                  <StatusThree :createTime="orderDetail.createTime" v-if="orderDetail._status._type==2" :payType="orderDetail._status._payType"></StatusThree>
                  <StatusFour :receiveTime="orderDetail.receiveTime" :createTime="orderDetail.createTime" v-if="orderDetail._status._type==3" :payType="orderDetail._status._payType"></StatusFour>
                  <StatusFive :createTime="orderDetail.createTime" v-if="orderDetail._status._type==4 " :payType="orderDetail._status._payType"></StatusFive>
              </div>
          </div>
          <div class="logistics" v-if="orderDetail.state===3 || orderDetail.state===4">
              <p class="fs16 font-color-333">物流信息</p>
              <div class="content">
                  <div class="left">
                      <img src="../../../static/image/wuliuxin@2x.png" alt="">
                      <div>
                          <p>发货方式：快递</p>
                          <p>物流公司：{{orderDetail.express}}</p>
                          <p>运单号码：{{orderDetail.deliverFormid}}</p>
                      </div>
                  </div>
                  <div class="right">
                      <div class="title">物流跟踪：</div>
                      <div class="dilevery">
                          <!-- <div v-for="(item, index) in dilevery" :key="index" :class="index==0?'active':''">
                              <span class="dot">
                                  <span class="line"></span>
                              </span>
                              <p>{{item.time}}&emsp;{{item.reason}}</p>
                          </div> -->
                          <el-steps direction="vertical" :active="1" space="100">
                            <el-step :title="item.time+'：'+item.reason" v-for="(item, index) in dilevery" :key="index"></el-step>
                          </el-steps>
                      </div>
                  </div>
              </div>
          </div>
          <div class="desc">
              <div class="receivingInfo" style="position: relative;">
                  <p class="title">收货信息</p>
                  <div class="info">
                      <p>收货地址：{{orderDetail.userProvince != null? orderDetail.userProvince+orderDetail.userCity+orderDetail.userDistrict+orderDetail.userAddress : orderDetail.userAddress}}</p>
                      <p>收货人：{{orderDetail.realName}}</p>
                      <p>收货电话：{{orderDetail.userPhone}}</p>
                  </div>
				  <a @click.prevent="updateAddress" class="updateAddr" v-if="orderDetail._status._type==1 || orderDetail._status._type==0">修改地址</a>
              </div>
              <!-- <div class="storeInfo">
                  <p class="title">卖家信息</p>
                  <div class="info">
                      <p>店铺名称：{{orderDetail.shopName}}</p>
                      <p>联系电话：{{orderDetail.chargePersonPhone}}</p>
                  </div>
              </div> -->
              <div class="orderInfo">
                  <p class="title">订单信息</p>
                  <div class="info">
                      <p>订单号：{{orderDetail.orderCd}}</p>
                      <p v-if="orderDetail.state==2 || orderDetail.state==3 || orderDetail.state==4">支付渠道：{{orderDetail.paymentMode}}</p>
                      <p v-if="orderDetail.state==2 || orderDetail.state==3 || orderDetail.state==4">交易号：{{orderDetail.transactionId}}</p>
                      <p>创建时间：{{orderDetail.createTime}}</p>
                      <p v-if="orderDetail.state==2 || orderDetail.state==3 || orderDetail.state==4">付款时间：{{orderDetail.paymentTime}}</p>
                      <p v-if="orderDetail.state==4">成交时间：{{orderDetail.receiveTime}}</p>
                      <p>备注：{{orderDetail.mark}}</p>
                  </div>
				  <div class="info">
				      <p>支付商户号：{{orderDetail.orderId}}</p>
				      <p>支付方式：{{orderDetail._status._payType}}</p>
				      <p>支付时间：{{orderDetail.payTime ? orderDetail.payTime.replace('T',' ').slice(0,19) : '未支付'}}</p>
				  </div>
				  <div class="info" v-if="orderDetail.deliveryId">
				      <p>快递单号：{{orderDetail.deliveryId}}</p>
				  </div>
              </div>
			  <!-- 快递信息 -->
			  <div class="receivingInfo" style="height: 195px;overflow: auto;position: relative;" v-if="orderDetail.deliveryId">
			      <p class="title">快递信息</p>
				  <!-- <a @click.prevent class="isOpen">展开</a> -->
            <div v-if="expressCode != '400'" class="info" v-for="(item,index) in expressList" :key="index">
			          <p style="flex: 1;">时间：{{item.time}}</p>
			          <p style="flex: 2;">到达地点：{{item.context}}</p>
			      </div>
            <div style="text-align: center;color: grey;" v-if="expressCode == '400'">
              暂无物流信息
            </div>
			  </div>

              <div class="productInfo">
                  <div class="top">
                      <span class="big">宝贝</span>
                      <span>宝贝属性</span>
                      <span>状态</span>
                      <span>数量</span>
                      <span>单价</span>
                  </div>
                  <div class="bottom" v-for="(pro, idx) in orderDetail.cartInfo" :key="pro.id">
                      <div class="big">
                          <img :src="pro.productInfo.image" alt="">
                          <p v-html="pro.productInfo.storeName"></p>
                      </div>
                      <div style="flex-direction: column;">
                          <!-- <p v-for="(text, ins) in pro.values" :key="ins">{{text}}</p> -->
						  <p v-if="pro.productInfo.attrInfo">{{pro.productInfo.attrInfo.sku}}</p>
                      </div>
                      <div v-if="orderDetail.status==-1">申请退款</div>
                      <div v-if="orderDetail.status==-2">退货成功</div>
                      <div v-if="orderDetail.status==0">待发货</div>
                      <div v-if="orderDetail.status==1">待收货</div>
                      <div v-if="orderDetail.status==2">已收货</div>
                      <div v-if="orderDetail.status==3">已完成</div>
                      <div>{{pro.cartNum}}</div>
                      <div class="font-color-FF7 fs-bold">¥{{pro.truePrice.toFixed(2)}}</div>
                  </div>
              </div>
              <div class="settlement">
                  <div class="box">
                      <div class="left">
                          <p>运费：<span class="right">¥{{orderDetail.totalPostage}}</span></p>
                          <p>平台优惠：<span class="right">-¥{{orderDetail.couponPrice}}</span></p>
                         <p>商品总价：<span class="right" style="color:#FF7800;">¥{{orderDetail.totalPrice }}</span></p>
                        <p v-if="orderDetail.payType=='payByArrive'" class="mar-top-20">需付款：<span class="right" style="color:#FF7800;">¥{{orderDetail.payPrice}}</span></p>
                          <p v-else class="mar-top-20">实付款：<span class="right" style="color:#FF7800;">¥{{orderDetail.payPrice}}</span></p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
	  <el-dialog
	    title="修改地址"
	    :visible.sync="updateAddressDialog"
	    width="40%"
	    :before-close="handleClose">
	    <div class="addressItem2"  v-for="(item, index) of addressData" :key="index">
	    				 <el-radio v-model="radio" :label="item.id" @change="changeAddr">选择地址</el-radio>
	      <span class="userName mr10">{{item.realName}}</span>
	      <span class="addressInfo mr10" style="flex: 2;">{{item.province}}{{item.city}} {{item.district}}{{item.detail}}</span>
	      <span class="phone mr10">{{item.phone}}</span>
	    </div>
	    <span slot="footer" class="dialog-footer">
	      <el-button @click="updateAddressDialog = false">取 消</el-button>
	      <el-button type="primary" @click="confirmUpdate">确 定</el-button>
	    </span>
	  </el-dialog>
  </div>
  </div>
</template>
<script>
import StatusOne from '../../components/status/statusOne'
import StatusTwo from '../../components/status/statusTwo'
import StatusThree from '../../components/status/statusThree'
import StatusFour from '../../components/status/statusFour'
import StatusFive from '../../components/status/statusFive'
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
import lateralNavigation2 from "../../components/base/lateralNavigation2";
import rightNav from "../../components/canvasShow/rightNav";
export default {
  mixins: [listSearchMixin],
    components: {
        StatusOne,
        StatusTwo,
        StatusThree,
        StatusFour,
        StatusFive,
        lateralNavigation2,
        rightNav
    },
    data () {
        return {
          orderDetail: {},
          value: '',
          values: '',
          textarea: '',
          textarea1: '',
          text: '',
          dialogImageUrl: '',
          dialogVisible: false,
          disabled: false,
          orderId: '',
          dilevery: [],
          endTime: '',
          expressList: [],
          expressCode: '',
          updateAddressDialog: false,
          addressData: [],
          radio: ''
        }
    },
    created () {
      this.orderId = this.$route.query.orderId
		  console.log(this.orderId)
    },
    mounted () {
      this.getOrderDetail()
		  this.getAddressData()
    },
    computed: {
      // 计算总价
      // totalPrice(){
      // return this.orderDetail.cartInfo.reduce((pre,cur)=>{
      // return pre += cur.cartNum * cur.truePrice
      // },0)
      // }
    },
    methods: {
		// 确认修改地址
      confirmUpdate(){
        let selectAddr = this.addressData.filter(item => item.id == this.radio)
        console.log(selectAddr)
        let userAddress = selectAddr[0].province + ' ' + selectAddr[0].city + ' ' + selectAddr[0].district + ' ' + selectAddr[0].detail + ' '
        let params = {
          url: api.updateOrderAddress,
          method: 'post',
          data: {
            orderId: this.orderDetail.orderId,
            realName: selectAddr[0].realName,
            userAddress,
            userPhone: selectAddr[0].userPhone
          }
        }
        console.log('----------------',selectAddr)
        this.sendReq(params,res => {
          console.log(res)
          if(res.success){
            this.$message.success('修改成功！')
            this.getOrderDetail()
          }
          this.updateAddressDialog = false
        })
      },
      changeAddr(){
        console.log(this.radio)

      },
      //关闭dialog
      handleClose(){
        this.updateAddressDialog = false
      },
      //点击修改地址
      updateAddress(){
        this.updateAddressDialog = true
      },
      //获取地址
      getAddressData(){
        let self = this
        let params = {
          url: api.addressList,
          method: 'get',
          data: {
          }
        }
        self.sendReq(params, (res) => {
        console.log(res)
          if (res.success) {
        // let defaultAddr = {}
        // let index = res.data.findIndex(item => item.isDefault == 1)
        // res.data.forEach(item=>{
        // 	if(item.isDefault == 1) {
        // 		this.currentAddressId = item.id
        // 		this.addressId = item.id
        // 		defaultAddr = item
        // 		this.radio = item.id
        // 	}
        // })
          // if(index>=0){
          // 	res.data.splice(index,1)
          // 	res.data.unshift(defaultAddr)
          // }
          self.addressData= res.data;
          } else {
            self.$message.error(res.msg)
          }
        })
      },
      //获取物流信息
      getExpressInfo(){
        console.log("---ss-s-s-")
        console.log(this.orderDetail)
        let params = {
          // url: api.getExpressInfo + '/sfwl/202279326',
          url: api.getExpressInfo + '/' + this.orderDetail.deliverySn + '/' + this.orderDetail.deliveryId,
          method: 'GET',
          data: {
          }
        }
        this.sendReq(params, (res) => {
          console.log('-----',JSON.parse(res.data))
          this.expressList = JSON.parse(res.data).data
          this.expressCode = JSON.parse(res.data).returnCode;
        })
      },
      // 时间戳转分秒
      toHHmmss (date) {
          var timer = ''
          var minutes = parseInt((date % (1000 * 60 * 60)) / (1000 * 60))
          // var seconds = (date % (1000 * 60)) / 1000
          timer = (minutes < 10 ? ('0' + minutes) : minutes) + '分'
          return timer
      },
      // 获取订单详情
      getOrderDetail () {
        let self = this
        let params = {
          url: api.getOrderDetail + '/' + self.orderId,
          method: 'GET',
          data: {
          }
        }
        self.sendReq(params, (res) => {
          if (res.success) {
            self.orderDetail = res.data
            self.endTime = self.toHHmmss(res.data.time)
            this.getExpressInfo()

          } else {
              self.$message({
                  message: res.msg,
                  type: 'error'
              });
          }
        })
      },
      // 查询物流信息
      getDilevery () {
        let self = this
        let params = {
          url: api.getDilevery + `?express=${self.orderDetail.express}` + `&deliverFormid=${self.orderDetail.deliverFormid}`,
          method: 'GET',
          data: {
          }
        }
        self.sendReq(params, (res) => {
          if (res.success) {
            // console.log(res)
            self.dilevery = res.data
          } else {
              self.$message({
                  message: res.message,
                  type: 'warning'
              })
          }
        })
      },
      // 取消订单
      cancelOrder () {
        console.log("取消订单");
          let self = this
          let params = {
            url: api.cancelOrder,
            method: 'POST',
            data: {
              orderId: self.orderDetail.orderId
            }
          }
          self.sendReq(params, (res) => {
            // console.log(res)
            if (res.success) {
                self.getOrderDetail()
            } else {
              self.$message({
                  message: res.message,
                  type: 'warning'
              })
          }
          })
      },
      // 去付款
      pay () {
          /* let self = this
          let params = {
              url: api.pay,
              method: 'PUT',
              data: {
                orderId: self.orderDetail.orderId,
                type: 2,
                money: self.orderDetail.price
              }
          }
          self.sendReq(params, (res) => {
            if (res.success) {
               self.getOrderDetail()
            } else {
              self.$message({
                  message: res.message,
                  type: 'warning'
              })
            }
          }) */
      },
      handleRemove (file) {
        // console.log(file)
      },
      handlePictureCardPreview (file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      handleDownload (file) {
        // console.log(file)
      }
    }
}
</script>
<style lang="scss" >
	.mr10 {
		margin-right: 10px;
	}
	.addressItem2 {
		margin: 10px 0;
		display: flex;
		span {
			flex: 1;
		}
	}
	.updateAddr {
		color: #ff7800;
		text-decoration: underline;
		position: absolute;
		right: 150px;
		top: 30px;
	}
	.isOpen {
		position: absolute;
		right: 0;
		top: 10px;
	}
.orderDetail{
    width: 100%;
    .banxin{
        width: 1252px;
        margin: 0 auto;
        .head {
            width: 100%;
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            display: flex;
            align-items: center;
            .arrow {
                background-image: url('../../../static/image/xiangyou@2x.png');
                width: 5px;
                height: 10px;
                margin-right: 10px;
            }
        }
        .status{
            width: 100%;
            height: 250px;
            border: 1px solid #E5E5E5;
            box-sizing: border-box;
            padding: 15px;
            display: flex;
            margin-bottom: 20px;
            .left{
                flex: 1;
                border-right: 1px solid #E5E5E5;
                display: flex;
                align-items: center;
                flex-direction: column;
                .cancel{
                    width: 100px;
                }
                .pay{
                    width: 100px;
                    border-color: #FF7800;
                    color: #FF7800;
                    margin-left: 0;
                }
                .pay:hover{
                    background-color: rgba($color: #FF7800, $alpha: 0.3);
                }
                .box{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
            }
            .right{
                flex: 3;
                padding:0 20px;
                box-sizing: border-box;
            }
        }
        .logistics{
            padding: 25px;
            width: 100%;
            box-sizing: border-box;
            margin-bottom: 20px;
            border: 1px solid #E5E5E5;
            .content{
                display: flex;
                .left{
                    padding: 20px 0;
                    flex: 2;
                    display: flex;
                    align-items: center;
                    box-sizing: border-box;
                    border-right: 2px solid #E5E5E5;
                    img{
                        width: 200px;
                        height: 200px;
                        margin-right: 40px;
                    }
                    div{
                        p{
                            font-size: 14px;
                            color: #666666;
                            margin-bottom: 20px;
                        }
                    }
                }
                .right{
                    flex: 3;
                    padding: 20px;
                    box-sizing: border-box;
                    display: flex;
                    .dilevery{
                        height: 280px;
                        width: 600px;
                        overflow-x: auto;
                        padding: 20px;
                        box-sizing: border-box;
                        // div{
                        //     padding-left: 25px;
                        //     margin-bottom: 25px;
                        //     position: relative;
                        //     box-sizing: border-box;
                        //     white-space: nowrap;
                        //     .dot{
                        //         // display: inline-block;
                        //         width: 6px;
                        //         height: 6px;
                        //         border-radius: 3px;
                        //         background-color: #D9D9D9;
                        //         margin-right: 10px;
                        //         position: absolute;
                        //         left: 0;
                        //         top: 50%;
                        //         transform: translate(50%,0);
                        //         .line{
                        //             position: absolute;
                        //             left: 50%;
                        //             top: 12px;
                        //             transform: translate(-50%,0);
                        //             width: 2px;
                        //             height: 25px;
                        //             background-color: #F1F1F1;
                        //         }
                        //     }
                            // .line{
                            //     width: 100%;
                            //     border-left: 2px solid #F1F1F1;
                            //     height: 25px;
                            //     margin-left: -21px;
                            // }
                        // }
                        // div:last-child{
                        //     margin-bottom: 0;
                        //     .line{
                        //         display: none;
                        //     }
                        // }
                        // .active{
                        //     .dot{
                        //         background-color: #FF7800;
                        //     }
                        // }
                    }
                }
            }
        }
        .desc{
            width: 100%;
            border: 1px solid #E5E5E5;
            margin-bottom: 140px;
            .receivingInfo,.storeInfo,.orderInfo{
                padding: 25px;
                border-bottom: 1px solid #E5E5E5;
                .title{
                    font-size: 16px;
                    margin-bottom: 25px;
                }
                .info{
                    display: flex;
                    margin-left: 75px;
                    flex-wrap: wrap;
                    p{
                        line-height: 30px;
                        width: 50%;
                        font-size: 14px;
                    }
                }
            }
            .orderInfo,.receivingInfo{
                .info{
                    p{
                        width: 33.33%;
                    }
                }
            }
            .productInfo{
                width: 100%;
                .top{
                    height: 40px;
                    width: 100%;
                    background-color: #EDEDED;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    span{
                        flex: 1;
                        font-size: 12px;
                    }
                    .big{
                        flex: 2;
                    }
                }
                .bottom{
                    width: 100%;
                    padding: 20px 0;
                    box-sizing: border-box;
                    text-align: center;
                    display: flex;
                    border-bottom: 1px solid #E5E5E5;
                    div{
                        flex: 1;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        p{
                            font-size: 14px;
                            line-height: 20px;
                        }
                    }
                    .big{
                        text-align: left;
                        flex: 2;
                        display: flex;
                        box-sizing: border-box;
                        justify-content: flex-start;
                        align-items: center;
                        img{
                            width: 80px;
                            height: 80px;
                            margin: 0 20px;
                        }
                        p{
                            width: 50%;
                        }
                    }
                }
            }
            .settlement{
                width: 100%;
                display: flex;
                padding: 25px;
                box-sizing: border-box;
                justify-content: flex-end;
                .box{
                    display: flex;
                    .left{
                        text-align: right;
                        p{
                            width: 250px;
                            display: flex;
                            justify-content: space-between;
                            font-size: 20px;
                            color: #666666;
                            line-height: 30px;
                        }
                        .right{
                            text-align: right;
                            margin-left: 40px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/orderDetail/index.vue